import { Vector3 } from "three";
import getTooltipByType from "./getTooltipByType";
import { DEFAULT_NEXT_IMAGE_DURATION, GALLERY_MODE } from "./imageGalleryHelper";

const generate_template = (type, props) => {
    let template = {};

    const tooltip = getTooltipByType(type);

    switch (type) {
        case 'guestSeat':
            template = {
                "id": props.unique_id,
                "type": "guestSeat",
                "name": "Gast Sitzplatz",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance,
                "scale": 1,
                "profile": {},
                "hideOnStart": false,
                tooltip
            }
            break;
        case 'imageGallery':
            template = {
                "id": props.unique_id,
                "type": "imageGallery",
                "name": "Image Gallery",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance,
                "scale": 1,
                "profile": {},
                "images": [],
                "autoplay": "1",
                "galleryMode": GALLERY_MODE.STATIC,
                "nextImageDuration": DEFAULT_NEXT_IMAGE_DURATION,
                "useIcon": false,
                "previewImage": {
                    "url": "",
                    "aspectRatio": 1
                },
                "topLeft": new Vector3(64, -64, 0),
                "topRight": new Vector3(64, 64, 0),
                "bottomRight": new Vector3(-64, 64, 0),
                "bottomLeft": new Vector3(-64, -64, 0),
                "original": {
                    "topLeft": new Vector3(64, -64, 0),
                    "topRight": new Vector3(64, 64, 0),
                    "bottomRight": new Vector3(64, -64, 0),
                    "bottomLeft": new Vector3(-64, -64, 0),
                },
                "hideOnStart": false,
                tooltip
            }
            break;
        case 'videoGallery':
            template = {
                "id": props.unique_id,
                "type": "videoGallery",
                "name": "videoGallery",
                "autoplay": "1",
                "url": props.url,
                "transparentBackground": false,
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance,
                "scale": 1,
                "profile": {},
                "images": [],
                "topLeft": new Vector3(128, -128, 0),
                "topRight": new Vector3(128, 128, 0),
                "bottomRight": new Vector3(-128, 128, 0),
                "bottomLeft": new Vector3(-128, -128, 0),
                "original": {
                    "topLeft": new Vector3(128, -128, 0),
                    "topRight": new Vector3(128, 128, 0),
                    "bottomRight": new Vector3(128, -128, 0),
                    "bottomLeft": new Vector3(-128, -128, 0),
                },
                "hideOnStart": false,
                tooltip
            }
            break;

        case 'screenStream':
            template = {
                "id": props.unique_id,
                "type": "screenStream",
                "name": "screenStream",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": 530,
                "scale": 1,
                "whoCanStream": props.whoCanStream,
                "hideOnStart": false,
                tooltip
            }
            break;
        case 'tourScreenShare':
            template = {
                "id": props.unique_id,
                "type": "tourScreenShare",
                "name": "tourScreenShare",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": 530,
                "scale": 1,
                "hideOnStart": false,
                tooltip
            }
            break;

        case 'profile':
            template = {
                "id": props.unique_id,
                "type": "profile",
                "name": "Profile",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance,
                "scale": 1,
                "profile": {
                    "userId": props.userId,
                    "userName": props.userName,
                    "wpId": props.wpId,
                    "avatarImage": {
                        "type": "image",
                        "mediumPath": props.avatarURL
                    },
                    "name": "",
                    "email": "",
                    "dynamicProfileAvatar": props.dynamicProfileAvatar
                },
                "hideOnStart": false,
                tooltip
            }
            break;

        case 'sceneChange':
            template = {
                "id": props.unique_id,
                "type": "sceneChange",
                "name": "Szenenwechsel",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance,
                "scale": 1,
                "goToSceneId": props.targetSceneId, //"0000-0000-0000-0000-0000" => this static id will cause problems for chat and webrtc rooms
                "transition": "rotateAndFlow",
                "image": {
                    "url": props.imageSrc,
                    "aspectRatio": props.aspectRatio
                },
                "useIcon": props.useIcon !== false,
                "hideOnStart": false,
                tooltip
            }
            break;

        case 'webLink':
            template = {
                "id": props.unique_id,
                "type": "webLink",
                "name": "Link",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance,
                "scale": 1,
                "url": props.linkPath,
                "image": {
                    "url": props.imageSrc,
                    "aspectRatio": props.aspectRatio
                },
                "openNewWindow": props.openNewWindow,
                "useIcon": props.useIcon !== false,
                "hideOnStart": false,
                tooltip
            }
            break;

        case 'baglessRoom':
            template = {
                "id": props.unique_id,
                "type": "baglessRoom",
                "name": "baglessRoom",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance,
                "scale": 1,
                "url": props.linkPath,
                "image": {
                    "url": props.imageSrc,
                    "aspectRatio": props.aspectRatio
                },
                "openNewWindow": props.openNewWindow,
                "roomId": props.roomId,
                "roomName": props.roomName,
                "hideOnStart": false,
                tooltip
            }
            break;

        case 'shopLink':
            template = {
                "id": props.unique_id,
                "type": "shopLink",
                "name": "Products",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance,
                "scale": 1,
                "products": props.productsData,
                "hideOnStart": false,
                tooltip

                // "products": {
                //     data: props.productsData
                // }

            }
            break;

        case 'youtube':
            template = {
                "id": props.unique_id,
                "type": "youtube",
                "name": "youtube",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": 530,
                "scale": 1,
                "video_id": props.yt_id,
                "hideOnStart": false,
                tooltip
            }
            break;

        case 'iframeAgent':
            template = {
                "id": props.unique_id,
                "type": "iframeAgent",
                "name": "iframeAgent",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": 530,
                "scale": 1,
                "iframe_value": props.iframe_value,
                "iframe_width_enabled": props.iframe_width_enabled || false,
                "iframe_width": props.iframe_width || '',
                "iframe_height_enabled": props.iframe_height_enabled || false,
                "iframe_height": props.iframe_height || '',
                "hideOnStart": false,
                tooltip
            }
            break;

        case 'iframeElement':
            template = {
                "id": props.unique_id,
                "type": "iframeElement",
                "name": "iframeElement",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": 530,
                "scale": 1,
                "iframe_value": props.iframe_value,
                "iframe_width_enabled": props.iframe_width_enabled || false,
                "iframe_width": props.iframe_width || '',
                "iframe_height_enabled": props.iframe_height_enabled || false,
                "iframe_height": props.iframe_height || '',
                "perspectiveOffsets": props.perspectiveOffsets || null,
                "width": props.width || null,
                "height": props.height || null,
                "hideOnStart": false,
                tooltip
            }
            break;

        case 'timerElement':
            template = {
                "id": props.unique_id,
                "type": "timerElement",
                "name": "timerElement",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": 530,
                "scale": 1,
                "timePreset": props.timePreset || "0:10:0",
                "perspectiveOffsets": props.perspectiveOffsets || null,
                "width": props.width || null,
                "height": props.height || null,
                "hideOnStart": false,
                tooltip
            }
            break;

        case 'vraiAgent':
            const defaultCorner = (mx, my) => ({ x: mx, y: my, z: 0 });
            const compDefaults = (w, h, active, pos) => ({
                active,
                position: { x: pos.x, y: pos.y, z: pos.z ?? 0 },
                topLeft: defaultCorner(-w / 2, h / 2),
                topRight: defaultCorner(w / 2, h / 2),
                bottomRight: defaultCorner(w / 2, -h / 2),
                bottomLeft: defaultCorner(-w / 2, -h / 2)
            });
            template = {
                "id": props.unique_id,
                "type": "vraiAgent",
                "name": "vraiAgent",
                "perspectiveOffsets": props.perspectiveOffsets || null,
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": 530,
                "scale": 1,
                "VAPI_ASSISTANT_ID": props.VAPI_ASSISTANT_ID || '',
                "components": {
                    chair: compDefaults(160, 140, true, { x: -120, y: 0, z: 0 }),
                    camera: compDefaults(160, 140, false, { x: 120, y: 0, z: 0 }),
                    transcription: compDefaults(200, 80, false, { x: 0, y: -140, z: 0 })
                },
                "hideOnStart": false,
                "promptTranscriptModal": false,
                "vapiRoomPrompt": props.vapiRoomPrompt || '',
                tooltip
            }
            if (props.agent_image) template.agent_image = props.agent_image;
            if (props.chairName) template.chairName = props.chairName;
            if (props.chairScenario) template.chairScenario = props.chairScenario;
            break;

        case 'room':
            template = {
                "id": props.unique_id,
                "publicName": props.publicName,
                "startPositionX": null,
                "startPositionY": null,
                "background": {
                    "type": "image",
                    "mediumPath": props.imgSrc,
                    "sliceImage": true,
                    "rotationY": 0
                },
                "objects": [],
                "ambientAudio": {
                    "type": "audio"
                },
                "introAudio": {
                    "type": "audio"
                },
                "sceneRotationY": 0,
                "backgroundRotationX": 0,
                "backgroundRotationY": "0",
                "backgroundRotationZ": 0,
                "autorotateAfterSeconds": 0,
                "autorotateSpeed": 0.1,
                "actionIfBackgroundVideoEnds": "stop",
                "goToSceneIdAfterBackgroundVideoEnds": "",
                "weather": null,
                "publicStage": false,
                "locationWithPayment": {
                    "state": false,
                    "price": 0,
                    "duration": { "fromDate": "", "untilDate": "", "days": "" },
                    "email": "",
                    "description": ''
                }
            }
            break;

        case 'chessGame':
            template = {
                "id": props.unique_id,
                "type": "chessGame",
                "name": "chessGame",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance,
                "scale": 1,
                "hideOnStart": false,
                tooltip
            }
            break;

        case 'payPalDonation':
            template = {
                "id": props.unique_id,
                "type": "payPalDonation",
                "name": "payPalDonation",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance,
                "scale": 1,
                "donationURL": props.donationURL,
                "donationDescription": props.donationDescription,
                "image": {
                    "url": props.imageSrc,
                    "aspectRatio": props.aspectRatio
                },
                "hideOnStart": false,
                tooltip
            }
            break;

        case 'infoElement':
            template = {
                "id": props.unique_id,
                "type": "infoElement",
                "name": "infoElement",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance,
                "scale": 1,
                "layout": props.layout,
                "data": props.data,
                "advertisementLinks": false,
                "hideOnStart": false,
                tooltip
            }
            break;
        case 'inputFieldGuess':
            template = {
                "id": props.unique_id,
                "type": "inputFieldGuess",
                "name": "inputFieldGuess",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance ?? 540,
                "scale": 1,
                "size": 1,
                "width": props.width ?? 280,
                "height": props.height ?? 72,
                "title": props.title || '',
                "bodyText": props.bodyText || '',
                "timePreset": props.timePreset || '',
                "autocloseOnTrue": props.autocloseOnTrue ?? false,
                "autocloseOnFalse": props.autocloseOnFalse ?? false,
                "hideOnStart": false,
                tooltip
            }
            break;
        case 'inputField':
            template = {
                "id": props.unique_id,
                "type": "inputField",
                "name": "inputField",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance ?? 540,
                "scale": 1,
                "size": 1,
                "width": props.width ?? 280,
                "height": props.height ?? 72,
                "title": props.title || '',
                "bodyText": props.bodyText || '',
                "placeholder": props.placeholder || '',
                "fieldKey": props.fieldKey || '',
                "funnelStep": props.funnelStep || '',
                "validation": props.validation || 'required',
                "minLength": props.minLength ?? 1,
                "autocloseOnSubmit": props.autocloseOnSubmit ?? true,
                "hideOnStart": false,
                tooltip
            }
            break;
        case 'vrInvisibleAction':
            template = {
                "id": props.unique_id,
                "type": "vrInvisibleAction",
                "name": "VRInvisibleAction",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance,
                "scale": 1,
                "topLeft": new Vector3(-32, 32, 0),
                "topRight": new Vector3(32, 32, 0),
                "bottomRight": new Vector3(32, -32, 0),
                "bottomLeft": new Vector3(-32, -32, 0),
                "original": {
                    "topLeft": new Vector3(-32, 32, 0),
                    "topRight": new Vector3(32, 32, 0),
                    "bottomRight": new Vector3(32, -32, 0),
                    "bottomLeft": new Vector3(-32, -32, 0),
                },
                "showDragCorners": true,
                "hideOnStart": false,
                tooltip
            }
            break;

        case 'embeddedWebpage':
            template = {
                "id": props.unique_id,
                "type": "embeddedWebpage",
                "name": "embeddedWebpage",
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": props.defaultDistance,
                "scale": 1,
                "iframe": props.iframe,
                "image": props.image,
                "useIcon": props.useIcon !== false,
                "hideOnStart": false,
                tooltip
            }
            break;

        case 'vapiUserCamera':
            template = {
                "id": props.unique_id,
                "type": "vapiUserCamera",
                "name": "Vapi User Camera",
                "vapiAgentId": props.vapiAgentId,
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": 540,
                "scale": 1,
                "size": 1,
                "imageUrl": props.imageUrl || '',
                "commandText": props.commandText || '',
                "perspectiveOffsets": props.perspectiveOffsets || null,
                "hideOnStart": false,
                tooltip: ''
            }
            break;

        case 'vapiTranscription':
            template = {
                "id": props.unique_id,
                "type": "vapiTranscription",
                "name": "Vapi Transcription",
                "vapiAgentId": props.vapiAgentId,
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": 540,
                "scale": 1,
                "size": 1,
                tooltip: '',
                transcriptionUserColor: props.transcriptionUserColor ?? '#7dd3fc',
                transcriptionUserRoleColor: props.transcriptionUserRoleColor ?? '#ffffff',
                transcriptionAIColor: props.transcriptionAIColor ?? '#00d4aa',
                transcriptionAIRoleColor: props.transcriptionAIRoleColor ?? '#00d4aa',
                transcriptionBackgroundColor: props.transcriptionBackgroundColor ?? 'transparent',
                transcriptionPreset: props.transcriptionPreset ?? 'landscape',
                transcriptionWidth: props.transcriptionWidth,
                transcriptionHeight: props.transcriptionHeight,
                "hideOnStart": false
            }
            break;

        case 'vapiButton':
            template = {
                "id": props.unique_id,
                "type": "vapiButton",
                "name": props.name ?? "Vapi Command Action",
                "vapiAgentId": props.vapiAgentId,
                "x": 0,
                "y": 0,
                "z": 0,
                "rotateX": 0,
                "rotateY": 0,
                "distance": 540,
                "scale": 1,
                tooltip: '',
                commandName: props.commandName ?? ((typeof $trans !== 'undefined' && $trans('vapi-command-text')) || 'Command'),
                commandText: props.commandText ?? '',
                // Legacy keys kept for compatibility with existing worlds.
                label: props.label ?? '',
                action: props.action ?? '',
                icon: props.icon ?? '',
                imageUrl: props.imageUrl || '',
                perspectiveOffsets: props.perspectiveOffsets || null,
                "hideOnStart": false
            }
            break;

      case 'videoPlayer':
        template = {
          "id": props.unique_id,
          "type": "videoPlayer",
          "name": "Video Player",
          "x": 0,
          "y": 0,
          "z": 0,
          "rotateX": 0,
          "rotateY": 0,
          "distance": props.defaultDistance,
          "scale": 1,
          "profile": {},
          "images": [],
          "useIcon": true,
          "customImage": null,
          "topLeft": new Vector3(32, -32, 0),
          "topRight": new Vector3(32, 32, 0),
          "bottomRight": new Vector3(-32, 32, 0),
          "bottomLeft": new Vector3(-32, -32, 0),
          "original": {
            "topLeft": new Vector3(32, -32, 0),
            "topRight": new Vector3(32, 32, 0),
            "bottomRight": new Vector3(32, -32, 0),
            "bottomLeft": new Vector3(-32, -32, 0),
          },
          "hideOnStart": false,
          tooltip
        }
        break;
      case 'videoPlayerWebGL':
        template = {
          "id": props.unique_id,
          "type": "videoPlayerWebGL",
          "name": "Video Background",
          "x": 0,
          "y": 0,
          "z": 0,
          "rotateX": 0,
          "rotateY": 0,
          "distance": props.defaultDistance,
          "scale": 1,
          "profile": {},
          "images": [],
          "useIcon": false,
          "placeAs3dElement": true,
          "scene3dPerspectiveApplied": false,
          "customImage": null,
          "placeholderImage": null,
          "autoplay": false,
          "playLoop": true,
          "playOnClick": true,
          "transparentBackground": false,
          "topLeft": new Vector3(-128, 128, 0),
          "topRight": new Vector3(128, 128, 0),
          "bottomRight": new Vector3(128, -128, 0),
          "bottomLeft": new Vector3(-128, -128, 0),
          "original": {
            "topLeft": new Vector3(-128, 128, 0),
            "topRight": new Vector3(128, 128, 0),
            "bottomRight": new Vector3(128, -128, 0),
            "bottomLeft": new Vector3(-128, -128, 0),
          },
          "hideOnStart": false,
          tooltip
        }
        break;
      case 'vrMusicObject':
        template = {
          "id": props.unique_id,
          "type": "vrMusicObject",
          "name": "Music Object",
          "audioUrl": "",
          "x": 0,
          "y": 0,
          "z": 0,
          "rotateX": 0,
          "rotateY": 0,
          "distance": props.defaultDistance,
          "scale": 1,
          "hideOnStart": false,
          tooltip
        }
        break;
    }

    return template;
}

export default generate_template;
